import styled from 'styled-components';

export const Head = styled.div`
    display: flex;
    align-items: center;
    padding: 25px 30px;
    justify-content: space-between;
    background: var(--color-primary-100);

    div {
        flex: 1;
    }

    .f-2 {
        flex: 2;
    }
`;

export const Body = styled.div`
    padding: 10px 30px;
    display: flex;
    justify-content: space-between;

    div {
        flex: 1;
    }

    .f-2 {
        flex: 2;
    }
`;

export const Wrap = styled.div`
    margin-bottom: 15px;
`;

export const SiteUL = styled.ul`
    li {
        line-height: 1.6;
        font-weight: 500;
        margin-bottom: 5px;
    }
`;
